import {
  fetchInstoreOrderAsync,
  instoreOrdersSelectors,
} from "./instoreOrdersSlice";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { fetchInstoreOrderTypesAsync } from "../instoreOrderTypes/instoreOrderTypesSlice";
import { fetchInstoreTemplatesAsync } from "../instoreTemplates/instoreTemplatesSlice";
import { fetchInstoreThemesAsync } from "../instoreThemes/instoreThemesSlice";
import { fetchInstoreTypesAsync } from "../instoreTypes/instoreTypesSlice";
import { fetchCountriesAsync } from "../countries/countriesSlice";
import { fetchLanguagesAsync } from "../languages/languageSlice";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import InstoreOrderDetailContainer from "../../components/instoreOrderDetail/InstoreOrderDetailContainer";
import { fetchDigitalFramesAsync } from "../digitalFrames/digtalFramesSlice";

//#region INTERFACE
interface Props {
  readonly?: boolean;
  create?: boolean;
}
//#endregion

export default function InstoreOrderDetailPage({
  readonly = false,
  create = false,
}: Props) {
  //#region LOGIC
  // Router
  const { id } = useParams<{ id: string }>();

  // Redux
  const dispatch = useAppDispatch();
  const { instoreTemplates_Loaded } = useAppSelector(
    ({ instoreTemplates }) => instoreTemplates
  );
  const { instoreThemes_Loaded } = useAppSelector(
    ({ instoreThemes }) => instoreThemes
  );
  const { digitalFrames_loaded } = useAppSelector(
    ({ digitalFramesManagement }) => digitalFramesManagement
  );
  const { instoreTypes_Loaded } = useAppSelector(
    ({ instoreTypes }) => instoreTypes
  );
  const { instoreOrderTypes_Loaded } = useAppSelector(
    ({ instoreOrderTypes }) => instoreOrderTypes
  );
  const { languages_loaded } = useAppSelector(
    ({ languagesManagement }) => languagesManagement
  );
  const { countries_loaded } = useAppSelector(
    ({ countriesManagement }) => countriesManagement
  );

  const instoreOrder = useAppSelector((state) =>
    instoreOrdersSelectors.selectById(state, id)
  );
  //#endregion

  //#region LOGIC
  useEffect(() => {
    const fetchData = async (id: number) => {
      await dispatch(fetchInstoreOrderAsync(id));
    };
    id && !create && fetchData(Number(id));
  }, [id, create, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchInstoreTemplatesAsync());
    };
    !instoreTemplates_Loaded && fetchData();
  }, [instoreTemplates_Loaded, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchInstoreThemesAsync());
    };
    !instoreThemes_Loaded && fetchData();
  }, [instoreThemes_Loaded, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchInstoreTypesAsync());
    };
    !instoreTypes_Loaded && fetchData();
  }, [instoreTypes_Loaded, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchDigitalFramesAsync());
    };
    !digitalFrames_loaded && fetchData();
  }, [digitalFrames_loaded, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchInstoreOrderTypesAsync());
    };
    !instoreOrderTypes_Loaded && fetchData();
  }, [instoreOrderTypes_Loaded, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchLanguagesAsync());
    };
    !languages_loaded && fetchData();
  }, [languages_loaded, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchCountriesAsync());
    };
    !countries_loaded && fetchData();
  }, [countries_loaded, dispatch]);
  //#endregion

  //#region RENDER
  return (
    <InstoreOrderDetailContainer
      instoreOrder={instoreOrder}
      readOnly={readonly}
      create={create}
    />
  );
  //#endregion
}
